(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_95c6209"] && !Shopify.designMode) return;
  try {
    /*
   * CARPENGO Editorial Article TOC
   *
   * Shopify {% javascript %} does not process Liquid.
   * The component is therefore discovered generically.
   */

  (() => {

    const initializeArticleReading = (root) => {

      if (!root || root.dataset.initialized === 'true') {
        return;
      }

      const content = root.querySelector(
        '[class*="__content"]'
      );

      if (!content) {
        return;
      }

      const headings = Array.from(
        content.querySelectorAll('h2')
      );

      const wordCount = (content.innerText || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .length;


      /*
       * Only show TOC for genuinely long articles.
       */

      if (headings.length < 4 || wordCount < 750) {
        return;
      }

      root.dataset.initialized = 'true';

      root.classList.add('has-toc');


      /*
       * Create stable heading IDs.
       */

      headings.forEach((heading, index) => {

        if (!heading.id) {

          let base = (heading.textContent || '')
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');

          if (!base) {
            base = 'section';
          }

          heading.id =
            'article-section-' +
            base +
            '-' +
            index;

        }

      });


      /*
       * Populate both desktop and mobile TOCs.
       */

      const lists = root.querySelectorAll(
        '[class*="__toc-list"]'
      );

      lists.forEach((list) => {

        headings.forEach((heading) => {

          const item = document.createElement('li');

          const link = document.createElement('a');

          link.href = '#' + heading.id;

          link.textContent =
            (heading.textContent || '').trim();

          link.setAttribute(
            'data-toc-target',
            heading.id
          );

          item.appendChild(link);

          list.appendChild(item);


          /*
           * Smooth scrolling with header offset.
           */

          link.addEventListener('click', (event) => {

            event.preventDefault();

            const target =
              document.getElementById(heading.id);

            if (!target) {
              return;
            }

            const headerOffset = 110;

            const targetPosition =
              target.getBoundingClientRect().top +
              window.scrollY -
              headerOffset;

            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });


            /*
             * Close mobile TOC after selection.
             */

            const details =
              link.closest('details');

            if (details) {
              details.open = false;
            }

          });

        });

      });


      /*
       * Active heading tracking.
       */

      const links = Array.from(
        root.querySelectorAll(
          '[class*="__toc-list"] a'
        )
      );

      let ticking = false;


      const updateActiveHeading = () => {

        ticking = false;

        const activationPoint =
          window.scrollY + 150;

        let activeHeading = headings[0];


        headings.forEach((heading) => {

          const top =
            heading.getBoundingClientRect().top +
            window.scrollY;

          if (top <= activationPoint) {
            activeHeading = heading;
          }

        });


        if (!activeHeading) {
          return;
        }


        links.forEach((link) => {

          if (
            link.dataset.tocTarget ===
            activeHeading.id
          ) {

            link.setAttribute(
              'aria-current',
              'location'
            );

          } else {

            link.removeAttribute(
              'aria-current'
            );

          }

        });

      };


      const requestUpdate = () => {

        if (!ticking) {

          ticking = true;

          window.requestAnimationFrame(
            updateActiveHeading
          );

        }

      };


      window.addEventListener(
        'scroll',
        requestUpdate,
        { passive: true }
      );


      window.addEventListener(
        'resize',
        requestUpdate,
        { passive: true }
      );


      updateActiveHeading();

    };


    /*
     * Find all CARPENGO article blocks.
     */

    const boot = () => {

      document
        .querySelectorAll('[class*="ai-reading-"]')
        .forEach((element) => {

          if (
            element.tagName
              .toLowerCase()
              .startsWith('article-reading-')
          ) {

            initializeArticleReading(element);

          }

        });

    };


    /*
     * Initial page load.
     */

    if (document.readyState === 'loading') {

      document.addEventListener(
        'DOMContentLoaded',
        boot,
        { once: true }
      );

    } else {

      boot();

    }


    /*
     * Shopify Theme Editor dynamic reload.
     */

    document.addEventListener(
      'shopify:section:load',
      () => {
        setTimeout(boot, 50);
      }
    );

  })();
  } catch(e) { console.error(e); }
})();

})();
